module.exports = __webpack_public_path__ + "img/5.77432b17.png";